import Vue from 'vue'
import Vuetify, { VLayout } from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify, {
    iconfont: 'mdi',
    theme: {
        primary: '#B71C1C',
        secondary: '#37474F',
        accent: '#006dff',
        success: '#4DB6AC',
        info: '#90A4AE',
        error: '#E53935',
        warning: '#F9A825',

        bg_main: '#CFD8DC',
        text_header_primary: '#B71C1C',
        text_header_secondary: '#37474F',

        bg_navbar: '#ECEFF1',
        text_navbar: '#546E7A',

        bg_drawer: '#37474F',
        text_drawer_primary: '#CFD8DC',
        text_drawer_disabled: '#78909C',

        item_in_cart: '#FFCDD2',

        mob_item_title: '#E53935',
        mob_item_title_text: '#FFFFFF',
        mob_item_btn_in_cart: '#FFEE58',
    },
    components: {
        VLayout
    },
})
